<template>
  <Wrapper ref="wrapper" page-name="设备功能状态">
    <div class="app-container">
      <div class="left" shadow="never">
        <div slot="header" class="header-content">
          <span class="title">设备功能</span>
        </div>
        <!-- <div class="input-style">
          <el-input
            v-model="filterText"
            placeholder="输入区域名称进行过滤"
            suffix-icon="el-icon-search"
          />
        </div> -->
        <!-- 区域 -->
        <div class="areas">
          <el-tree
            ref="tree"
            :data="r_data"
            node-key="id"
            :expand-on-click-node="false"
            :default-expand-all="true"
            highlight-current
            :filter-node-method="filterNode"
            :default-expanded-keys="defaultExpandedKeys"
            :check-strictly="true"
            :current-node-key="currentNodeKey"
            @node-click="treeNodeClick"
            :props="{
              label: 'label',
              children: 'children',
              isLeaf: 'leaf'
            }"
          >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <i class="iconfont icon-shebeileixing"  v-if="data.deviceTypeId"></i>
            <i class="iconfont icon-shebeimingcheng"  v-if="data.deviceId"></i>
            <span :class="nodeClass(node)" class="tree-label">{{ node.label }}</span>
          </span>
          </el-tree>
        </div>
      </div>

      <div class="right">
        <div class="table-wrapper">
          <Table v-bind="table"  height="100%">
            <template slot="abilityStatusDescCode" slot-scope="{scope}">
              <span>{{ scope.abilityStatusDescCode?'高电平':'低电平' }}</span>
            </template>
            <template slot="abilityStatusDescType" slot-scope="{scope}">
              <span>{{ scope.abilityStatusDescType?'正常':'异常' }}</span>
            </template>
            <template slot="operate" slot-scope="{scope}">
              <div class="table-actions hand">
                <span @click="edite(scope)" style="color:#00AF84">编辑</span>
              </div>
            </template>
          </Table>
        </div>
        <!-- <Pagination
          v-bind="pagination"
          class="page-pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
        /> -->
      </div>

      <Dialogs title="修改状态" :is-show-dialog="isShowPage" width="26%" @handleClick="handleClose" :enterEvent="clickPage">
      <div slot="content">
        <el-form  ref="rowForm"  :model="formData"  label-width="120px">
          <el-form-item label="状态名称" prop="abilityStatusDesc" :rules="[{required: true,min:1, max:30, message: '必填项   1-30个字符', trigger: 'blur'}]">
            <el-input v-model="formData.abilityStatusDesc" placeholder="请输入" style="width:90%"/>
          </el-form-item>
          <el-form-item label="高低电平" prop="equipmentId">
            <el-select v-model="formData.abilityStatusDescCode" placeholder="请选择" style="width:90%">
              <el-option key="1" label="高电平" :value="1"></el-option>
              <el-option key="0" label="低电平" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态类型" prop="equipmentId">
            <el-select v-model="formData.abilityStatusDescType" placeholder="请选择" style="width:90%">
              <el-option key="1" label="正常" :value="1"></el-option>
              <el-option key="0" label="异常" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="btns">
        <div>
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="clickPage">保 存</el-button>
        </div>
      </div>
    </Dialogs>
    </div>
  </Wrapper>
</template>

<script>
import Wrapper from '@/components/page/Wrapper.vue'
import {getDeviceGroup, getAbilityInfo, updateAbilityStatus} from '@/api/deviceFunction'
import SearchBar from '@/components/page/SearchBar.vue'
import Table from '@/components/page/Table.vue'
// import Pagination from '@/components/page/Pagination.vue'
import Dialogs from '@/components/page/Dialogs.vue'

export default {
  name: 'AreaManage',
  components: {
    Wrapper,
    SearchBar,
    Table,
    // Pagination,
    Dialogs
  },
  directives: {
    focus: {
      inserted: function (el) {
        const inputDom = el.getElementsByTagName('input')[0]
        inputDom.focus()
      }
    }
  },
  data () {
    return {
      table: {
        selection: false, // 是否开启选择框
        tableInfo: [{
          key: 'id',
          name: '序号',
          minWidth: 40
        }, {
          key: 'abilityStatusDesc',
          name: '状态名称',
          minWidth: 200
        }, {
          key: 'abilityStatusDescCode',
          name: '高低电平',
          minWidth: 200,
          type: 'custom'
        }, {
          key: 'abilityStatusDescType',
          name: '状态类型',
          type: 'custom'
        }],
        tableData: []
      },
      // pagination: {
      //   total: 0,
      //   currentPage: 1,
      //   pageSize: 10
      // },
      // params: {
      //   pageNum: 1,
      //   pageSize: 10,
      //   deviceName: '',
      //   areaId: ''
      // },

      r_data: [],
      filterText: '',

      defaultExpandedKeys: [0],
      currentNodeKey: null,
      isShowPage: false,
      formData: {
        abilityStatusDesc: '开',
        abilityStatusDescCode: 1,
        abilityStatusDescType: 1
      },
      deviceInfoAbilityId: '',
      deviceInfoAbilityStatusId: ''

    }
  },
  computed: {
    nodeClass () {
      return (node) => {
        return node.level === 1 ? 'level1' : node.level === 2 ? 'level2' : 'level3'
      }
    }
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    }
    // params: {
    //   handler (v) {
    //     // this.getDeviceListAll()
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  mounted () {
    this.getTree()
  },

  methods: {
    currentChange (pageNum) {
      this.params.pageNum = pageNum
      this.$set(this.pagination, 'currentPage', pageNum)
    },
    sizeChange (pageSize) {
      this.params.pageSize = pageSize
      this.$set(this.pagination, 'pageSize', pageSize)
    },
    getTree () {
      let i = 0
      function transformData (obj) {
        obj.id = ++i
        obj.label = obj.deviceTypeName || obj.deviceName || obj.deviceTypeAbilityName
        obj.children = obj.simpleDeviceInfoList || obj.simpleDeviceInfoAbilityList
        obj.children && obj.children.forEach(item => transformData(item))
        return obj
      }
      getDeviceGroup().then((res) => {
        const {success, data} = res
        if (success) {
          data.forEach(item => {
            return transformData(item)
          })
          this.r_data = data
        }
      })
    },

    // tree 方法
    filterNode (value, data) {
      if (!value) return true
      return data.areaName.indexOf(value) !== -1
    },

    treeNodeClick (data, node) {
      this.deviceInfoAbilityId = data.deviceInfoAbilityId
      if (this.deviceInfoAbilityId) {
        this.getAbilityInfoAll(this.deviceInfoAbilityId)
      }
    },
    getAbilityInfoAll (deviceInfoAbilityId) {
      getAbilityInfo({deviceInfoAbilityId}).then(({success, data}) => {
        if (success) {
          this.$set(this.table, 'tableData', data)
        }
      })
    },
    edite (row) {
      this.isShowPage = true
      this.deviceInfoAbilityStatusId = row.id
      this.formData = JSON.parse(JSON.stringify(row))
    },
    handleClose () {
      this.isShowPage = false
      this.deviceInfoAbilityStatusId = ''
    },
    cancel () {
      this.handleClose()
    },
    clickPage () {
      const refForm = this.$refs.rowForm
      refForm.validate((valid) => {
        if (valid) {
          const {
              abilityStatusDesc,
              abilityStatusDescCode,
              abilityStatusDescType
          } = this.formData
          const params = {
            deviceInfoAbilityStatusId: this.deviceInfoAbilityStatusId,
            abilityStatusDesc,
            abilityStatusDescCode,
            abilityStatusDescType
          }

          updateAbilityStatus(params).then(({success}) => {
            if (success) {
              this.$message({
                type: 'success',
                message: `更新成功`
              })
              this.getAbilityInfoAll(this.deviceInfoAbilityId)
            }
            this.cancel()
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$baseColor: #0c75f0;
.app-container {
  height: 100%;
  display: flex;
  margin: 20px;
  overflow: hidden;
}
.left {
  flex-shrink: 0;
  width: 308px;
  height: 100%;
  background-color: #fff;
  border-radius: 4px;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  .header-content {
    flex-shrink: 0;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    &::after{
      content: '';
      height:0;
      width:100%;
      border-bottom: 1px solid #EDEEF2;
      position: absolute;
      bottom: 1px;
      left:0;
    }
    .title {
      font-family: MiSans;
      font-weight: 500;
      font-size: 16px;
      color: #32353B;
    }
  }
  .input-style {
    flex-shrink: 0;
    padding: 20px;
    border-top: 1px solid #EDEEF2;
    border-bottom: 1px solid #EDEEF2;
  }
  .areas {
    height: 0;
    flex-grow: 1;
    overflow-y: auto;
    padding: 10px 20px 20px;
    margin-bottom: 20px;
    &::-webkit-scrollbar {
      width: 0 !important
    }
  }
}
.right {
  position: relative;
  overflow: hidden;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  padding-bottom: 0;
  background-color: #fff;
  border-radius: 4px;
  .table-wrapper{
    height: calc(100% - 80px);  
  }
}

.hand {
  cursor: hand;
  cursor: pointer;
}

.custom-tree-node{
  font-size: 14px;
  .iconfont{
    // padding-right: 13px;
    color: #49515C;
  }
  .tree-label{
    font-family: MiSans;
    font-weight: 400;
    font-size: 14px;
    color: #49515C;
  }
  .level1{
    padding-left: 15px;
  }
  .level2{
    padding-left: 15px;
  }
  .level3{
    padding-left: 25px;
  }
}
::v-deep {
  .el-tree-node__children .treenode-title{
    font-weight: 400 !important;
  }
  .el-tree-node__content {
    height: 34px;
    padding-right: 10px;
  }
  .el-tree-node__content > label.el-checkbox {
    margin-right: 19px;
  }
  .left .custom-tree-node-wrapper .custom-tree-node .treenode-title {
    padding-left: 8px;
  }
}



</style>
